// extracted by mini-css-extract-plugin
export default {"progressIcon":"_1tLsI","succeeded":"_25NXs","failed":"rzo0F"};